/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ShareClaimPendingInviteResponseData } from './ShareClaimPendingInviteResponseData';
import {
    ShareClaimPendingInviteResponseDataFromJSON,
    ShareClaimPendingInviteResponseDataFromJSONTyped,
    ShareClaimPendingInviteResponseDataToJSON,
    ShareClaimPendingInviteResponseDataToJSONTyped,
} from './ShareClaimPendingInviteResponseData';

/**
 * No account existed for the email, so a pending invite was created and emailed.
 * @export
 * @interface ShareClaimPendingInviteResponse
 */
export interface ShareClaimPendingInviteResponse {
    /**
     * 
     * @type {boolean}
     * @memberof ShareClaimPendingInviteResponse
     */
    success: boolean;
    /**
     * 
     * @type {string}
     * @memberof ShareClaimPendingInviteResponse
     */
    kind: ShareClaimPendingInviteResponseKindEnum;
    /**
     * Always true for this variant. Retained for convenience alongside `kind`.
     * @type {boolean}
     * @memberof ShareClaimPendingInviteResponse
     */
    pending: boolean;
    /**
     * 
     * @type {ShareClaimPendingInviteResponseData}
     * @memberof ShareClaimPendingInviteResponse
     */
    data: ShareClaimPendingInviteResponseData;
}


/**
 * @export
 */
export const ShareClaimPendingInviteResponseKindEnum = {
    Pending: 'pending'
} as const;
export type ShareClaimPendingInviteResponseKindEnum = typeof ShareClaimPendingInviteResponseKindEnum[keyof typeof ShareClaimPendingInviteResponseKindEnum];


/**
 * Check if a given object implements the ShareClaimPendingInviteResponse interface.
 */
export function instanceOfShareClaimPendingInviteResponse(value: object): value is ShareClaimPendingInviteResponse {
    if (!('success' in value) || value['success'] === undefined) return false;
    if (!('kind' in value) || value['kind'] === undefined) return false;
    if (!('pending' in value) || value['pending'] === undefined) return false;
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function ShareClaimPendingInviteResponseFromJSON(json: any): ShareClaimPendingInviteResponse {
    return ShareClaimPendingInviteResponseFromJSONTyped(json, false);
}

export function ShareClaimPendingInviteResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ShareClaimPendingInviteResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'success': json['success'],
        'kind': json['kind'],
        'pending': json['pending'],
        'data': ShareClaimPendingInviteResponseDataFromJSON(json['data']),
    };
}

export function ShareClaimPendingInviteResponseToJSON(json: any): ShareClaimPendingInviteResponse {
    return ShareClaimPendingInviteResponseToJSONTyped(json, false);
}

export function ShareClaimPendingInviteResponseToJSONTyped(value?: ShareClaimPendingInviteResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'success': value['success'],
        'kind': value['kind'],
        'pending': value['pending'],
        'data': ShareClaimPendingInviteResponseDataToJSON(value['data']),
    };
}

